import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Locatie, LocatieUpdate } from './locatii.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LocatiiService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private getLocatiiUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.locatii.getLocatii;
    private getLocatiiActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.locatii.getLocatiiActive;
    private getLocatiiPublicUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.locatii.getLocatiiPublic;
    private storeLocatieUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.locatii.storeLocatie;
    private updateLocatieUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.locatii.updateLocatie;
    private deleteLocatieUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.locatii.deleteLocatie;
    private changeStatusActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.locatii.changeStatusLocatieActive;
    private changeStatusPublicUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.locatii.changeStatusLocatiePublic;
    private getLocatiiByModulUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.locatii.getLocatieByModule;

    constructor(private http: HttpClient) { }

    addLocatie(locatie: Locatie) {
        return this.http.post(this.storeLocatieUrl, locatie, this.httpOptions);
    }

    updateLocatie(locatie: LocatieUpdate) {
        return this.http.put(this.updateLocatieUrl, locatie, this.httpOptions);
    }

    deleteLocatie(id: number) {
        return this.http.delete(this.deleteLocatieUrl + id);
    }

    changeStatuseActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusePublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    getLocatii() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getLocatiiUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get compartimente active:', error);
                    return throwError(error);
                })
            );
    }

    getLocatiiActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getLocatiiActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get locatii active:', error);
                    return throwError(error);
                })
            );
    }

    getLocatiiPublic() {
        return this.http.get(this.getLocatiiPublicUrl, this.httpOptions);
    }

    getLocatiiByModulId(id: number) {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getLocatiiByModulUrl + id
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in getLocatiiByModulId:', error);
                    return throwError(error);
                })
            );
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
